/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FormFieldSelectValueValueModel } from './FormFieldSelectValueValueModel';
import {
    FormFieldSelectValueValueModelFromJSON,
    FormFieldSelectValueValueModelFromJSONTyped,
    FormFieldSelectValueValueModelToJSON,
} from './FormFieldSelectValueValueModel';

/**
 * 
 * @export
 * @interface FormFieldSelectValueModel
 */
export interface FormFieldSelectValueModel {
    /**
     * 
     * @type {string}
     * @memberof FormFieldSelectValueModel
     */
    type: FormFieldSelectValueModelTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FormFieldSelectValueModel
     */
    isSelected: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FormFieldSelectValueModel
     */
    isDefault: boolean;
    /**
     * 
     * @type {number}
     * @memberof FormFieldSelectValueModel
     */
    order: number;
    /**
     * 
     * @type {FormFieldSelectValueValueModel}
     * @memberof FormFieldSelectValueModel
     */
    value?: FormFieldSelectValueValueModel;
}


/**
 * @export
 */
export const FormFieldSelectValueModelTypeEnum = {
    PetType: 'PetType',
    Breed: 'Breed',
    GenderAndSterilization: 'GenderAndSterilization',
    Medication: 'Medication',
    MedicationAllergy: 'MedicationAllergy',
    HealthCondition: 'HealthCondition',
    RidingStyles: 'RidingStyles',
    PrimaryDiscipline: 'PrimaryDiscipline'
} as const;
export type FormFieldSelectValueModelTypeEnum = typeof FormFieldSelectValueModelTypeEnum[keyof typeof FormFieldSelectValueModelTypeEnum];


/**
 * Check if a given object implements the FormFieldSelectValueModel interface.
 */
export function instanceOfFormFieldSelectValueModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "isSelected" in value;
    isInstance = isInstance && "isDefault" in value;
    isInstance = isInstance && "order" in value;

    return isInstance;
}

export function FormFieldSelectValueModelFromJSON(json: any): FormFieldSelectValueModel {
    return FormFieldSelectValueModelFromJSONTyped(json, false);
}

export function FormFieldSelectValueModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormFieldSelectValueModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'isSelected': json['isSelected'],
        'isDefault': json['isDefault'],
        'order': json['order'],
        'value': !exists(json, 'value') ? undefined : FormFieldSelectValueValueModelFromJSON(json['value']),
    };
}

export function FormFieldSelectValueModelToJSON(value?: FormFieldSelectValueModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'isSelected': value.isSelected,
        'isDefault': value.isDefault,
        'order': value.order,
        'value': FormFieldSelectValueValueModelToJSON(value.value),
    };
}

